module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-main",
    class: {
      'fixed': _vm.appScroll
    }
  }, [_c('div', {
    staticClass: "search-main__box-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "search-main__header"
  }, [_c('img', {
    staticClass: "header__bg",
    attrs: {
      "src": "static/img/header.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "search-main__desc"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.search.main.desc) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-main__box"
  }, [_vm._m(0), _vm._v(" "), _c('search-form')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-main__form-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/img/newspaper.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44934c90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchBlockMain.vue
// module id = 337
// module chunks = 1